// Created on 2026-02-07 by Farhan Khan - Create Quotation Flow
// Helper functions for lead quotation creation logic

import * as constants from "../constants/CONSTANT";

/**
 * Check if a lead status allows quotation creation
 * @param {string} leadStatus - The lead status to check
 * @returns {boolean} - True if quotation can be created, false otherwise
 */
export const canCreateQuotation = (leadStatus) => {
  if (!leadStatus) {
    return false;
  }

  // Get allowed statuses from constants
  const allowedStatuses = constants.LEAD_STATUS_VALUES
    .filter(status => 
      status.label === "Final Quotation" || 
      status.label === "Quotation Without Visit"
    )
    .map(status => status.label);

  return allowedStatuses.includes(leadStatus);
};

/**
 * Get allowed quotation creation statuses
 * @returns {string[]} - Array of allowed status labels
 */
export const getAllowedQuotationStatuses = () => {
  return constants.LEAD_STATUS_VALUES
    .filter(status => 
      status.label === "Final Quotation" || 
      status.label === "Quotation Without Visit"
    )
    .map(status => status.label);
};
